module.exports = __webpack_public_path__ + "img/red-packet.405a2720.png";